import { parse, isBefore } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

export const isPastTime = (time: string, timeZone: string) => {
    try {
        const now = toZonedTime(new Date(), timeZone);

        const parsedTime = parse(time, 'h:mma', now);

        return isBefore(parsedTime, now);
    } catch (error) {
        console.error('Invalid time format:', error);
        return false;
    }
};
